import { isSignedIn } from '../functions';

export const isNotSignedGuard = (to, from, next) => {
  to.meta.spa ? (!isSignedIn() ? next() : next.redirect('/spa')) : next();
};
